<template>
	<!-- small version-->
	<div v-if="isSmall" class="small-strip group flex flex-row items-center justify-end relative w-full  py-[2px] pr-[11px] cursor-pointer">
		<!-- hover version in small one -->
		<div class="absolute bottom-[30px] right-[-2px] hidden group-hover:flex  flex-col justify-center items-end w-[calc(100%+2px)] pt-[12px] pb-[11px] px-[20px] bg-[#EAE7F9]/[.64] border-r-2 border-primary-700">
			<div class="flex flex-row items-center">
				<div class="w-full flex flex-col items-end">
					<h2 class="font-bold text-lg text-primary-700">{{title}}</h2>
					<p class="font-regular text-xs text-primary-700 mt-[-5px]">{{subtitle}}</p>
				</div>
				<div class="h-[28px] w-[28px] rounded-full bg-complementary-600 flex-none ml-[8px] flex items-center justify-center p-[6px]">
					<icon-mishnat />
				</div>
			</div>
			<div class="w-fit mr-[36px] py-[3px] px-[8px] mt-[8px] rounded bg-secondary-500">
				<p class="text-sm text-secondary-900 font-medium">start ordering on sale</p>
			</div>
		</div>

			<p class="text-primary-700 font-semibold flex-1 text-right leading-[16px]">{{title}} <span class="font-regular">{{subtitle}}</span></p>
			<div class="h-[17px] w-[17px] p-[4px] ml-[8px] flex-none rounded-full bg-complementary-600">
				<icon-mishnat />
			</div>
	</div>
	<!-- big version-->
	<div v-else class="relative right-[-2px] flex flex-col justify-center items-end w-[calc(100%+2px)] pt-[12px] pb-[11px] px-[20px] bg-[#EAE7F9]/[.64] border-r-2 border-primary-700">
		<div class="flex flex-row items-center">
			<div class="w-full flex flex-col items-end">
				<h2 class="font-bold text-lg text-primary-700">{{title}}</h2>
				<p class="font-regular text-xs text-primary-700 mt-[-5px]">{{subtitle}}</p>
			</div>
			<div class="h-[28px] w-[28px] rounded-full bg-complementary-600 flex-none ml-[8px] flex items-center justify-center p-[6px]">
				<icon-mishnat />
			</div>
		</div>
		<div class="w-fit mr-[36px] py-[3px] px-[8px] mt-[8px] rounded bg-secondary-500">
			<p class="text-sm text-secondary-900 font-medium">start ordering on sale</p>
		</div>
	</div>
	
</template>

<script>
export default {
	name: "active-sale-event",
	props: {
		title: {
			type: String,
			required: true
		},
		subtitle: {
			type: String,
			required: true
		},
		isSmall: {
			type: Boolean,
			default: false,
		}
	}
}
</script>

<style>

</style>